import { LANGUAGE } from "../features/HomePage/helpers/constants";
import { languageConfigKeys } from "../helpers/tools";

export const filterLanguagesByCountry = (normalizedCountry) => {
  const languages = languageConfigKeys();
  return languages.filter((item) => {
    if (item.name === LANGUAGE.SPANISH) {
      return item.country.trim().toLowerCase() === normalizedCountry;
    }
    return true;
  });
};
